import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'

@vservice()
export class AdminContentCampaignSaveProfitUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  isSuccess = false
  isLoading = false

  execute(contentCampaignId: number, data: ProfitRequest) {
    return this.service.saveProfit(contentCampaignId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}